import { fireEvent } from '../../../Utils/fireEvent';

export const fireBundleEventHandler = (data) => {
  const pricingParam =
    data?.strikePrice + ', ' + data?.price + ', ' + 0 + ', ' + 'NA';
  const conversionParam = data?.price + ', ' + 0 + ', ' + (data?.price + 0);
  const nickname = data?.title;
  fireEvent({
    category: 'clicked_option',
    id: data?.id?.toString(),
    screen_name: 'PDP',
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    selling_price: data?.price,
    sku_nickname: nickname,
    parent: 'select_bundle_size',
    option: data?.title,
  });
};
